import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import "@fontsource/ibm-plex-sans/400.css";
import "@fontsource/ibm-plex-sans/500.css";
import "@fontsource/ibm-plex-sans/600.css";
import "@fontsource/ibm-plex-sans/700.css";
import "@fontsource-variable/manrope";
import "@fontsource-variable/jetbrains-mono";
import "./styles.css";
import { router } from "./router";
import { OturumSaglayici } from "./lib/oturum";
import { cevir } from "@/lib/dil";

const el = document.getElementById("root");
if (!el) throw new Error(cevir("#root not found"));

createRoot(el).render(
  <StrictMode>
    <OturumSaglayici>
      <RouterProvider router={router} />
    </OturumSaglayici>
  </StrictMode>,
);
